import React, { useState, useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './Navbar.css';
import '../common/Allcommon.css';
import { useTranslation } from 'react-i18next';
import i18next from "i18next";
// nav icon images
import bitcoinIcon from '../../assets/images/nav-icon/bitcoin.svg';
import ethereumIcon from '../../assets/images/nav-icon/ethereum.svg';
import referralIcon from '../../assets/images/nav-icon/referral-program-icon.svg';
import affiliateIcon from '../../assets/images/nav-icon/affiliate-program-icon.svg';
import howworksIcon from '../../assets/images/nav-icon/how-it-works.svg';
import statusIcon from '../../assets/images/nav-icon/status-page.svg';
import faqIcon from '../../assets/images/nav-icon/faq.svg';
import contactIcon from '../../assets/images/nav-icon/contact-support.svg';
import { Link, NavLink } from 'react-router-dom';
// import Languageoption from '../language-dropdown';

const Navbar = ({ auth, onLoginClick, onSignupClick, userName, userEmail, isDashboardNavbar, navText }) => {
  const [isFixed, setIsFixed] = useState(false);
  const { t } = useTranslation(); // i18next hook to get translations

  // Handle language change
  const handleLanguageChange = (languageCode) => {
    i18next.changeLanguage(languageCode); // Change language using i18next
  };

  useEffect(() => {
    const images = [
      bitcoinIcon,
      ethereumIcon,
      referralIcon,
      affiliateIcon,
      howworksIcon,
      statusIcon,
      faqIcon,
      contactIcon
    ];

    // Preload all images
    images.forEach(image => {
      const img = new Image();
      img.src = image;
    });

    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header role="banner" className={`header ${isFixed ? "fixed" : ""}`}>
        <nav className="navbar navbar-expand-md navbar-dark bg-dark">
          <div className="container">
            <Link className="navbar-brand" to="/">
              <img src='assets/images/logo-new.svg' alt='Brand' />
            </Link>
            <button className="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarsExample05" aria-controls="navbarsExample05" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon">
                <img className="menu-bar" src="assets/images/menu-bar.png" alt="menu bar" />
                <img src="assets/images/close.png" className="close-manu" alt="#" />
              </span>
            </button>

            <div className="collapse navbar-collapse" id="navbarsExample05">
              {
                isDashboardNavbar ? (
                  <ul className="navbar-nav pl-lg-5" data-toggle="collapse" data-target="#navbarsExample05" aria-controls="navbarsExample05" aria-expanded="false" aria-label="Toggle navigation">
                    <li className="nav-item">
                      <Link className="nav-link" to="#">
                        {navText}
                      </Link>
                    </li>
                  </ul>
                ) : (
                  <ul className="navbar-nav ml-auto pl-lg-5 pl-0"  data-toggle="collapse" data-target="#navbarsExample05" aria-controls="navbarsExample05" aria-expanded="false" aria-label="Toggle navigation">
                    <li className="nav-item">
                      <Link className="nav-link" to="/how-it-works">
                        How it Works
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/about-us">About us</Link>
                    </li>
                    <li className="nav-item dropdown">
                      <Link className="nav-link" to="/faq"
                      //  id="dropdown04" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                      >
                        FAQ
                      </Link>
                      {/* <div className="dropdown-menu" aria-labelledby="dropdown04">
                    <a className="dropdown-item" href="#">Food Catering</a>
                    <a className="dropdown-item" href="#">Drink &amp; Beverages</a>
                    <a className="dropdown-item" href="#">Wedding &amp; Birthday</a>
                  </div> */}
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/contact-us">Contact Us</Link>
                    </li>

                  </ul>
                )
              }

              {
                isDashboardNavbar ? (
                  <ul class="navbar-nav ml-auto rt-btn uesernav desh-board"  data-toggle="collapse" data-target="#navbarsExample05" aria-controls="navbarsExample05" aria-expanded="false" aria-label="Toggle navigation">
                    <li className="nav-item signup d-flex mx-3">
                      <Link className="nav-link" to="#">
                        {userName ? userName.slice(0, 1).toUpperCase() : ""}
                      </Link>
                    </li>
                    <li className='userDetails-nav'>
                      <Link class="user-link" to="#">
                        <p>{userName}</p>
                        {userEmail}
                      </Link>
                    </li>
                  </ul>
                ) : (
                  <ul className="navbar-nav ml-auto rt-btn" data-toggle="collapse" data-target="#navbarsExample05" aria-controls="navbarsExample05" aria-expanded="false" aria-label="Toggle navigation">
                    {/* <li className="nav-item">
                  <Languageoption onChange={handleLanguageChange} />
                </li> */}
                    {auth ? (
                      <>
                        <li className="nav-item signin d-flex">
                          <Link className="nav-link" to="/dashboard">
                            {t('dashboard')}
                          </Link>
                        </li>
                        <li className="nav-item signup d-flex">
                          <Link className="nav-link" to="#">{userName ? userName.slice(0, 1).toUpperCase() : ""}</Link>
                        </li>
                      </>
                    ) : (
                      <>
                        <li className="nav-item signin d-flex">
                          <a type='button' className="nav-link" onClick={onLoginClick}>
                            {t('login')}
                          </a>
                        </li>
                        <li className="nav-item signup d-flex">
                          <a type='button' className="nav-link" onClick={onSignupClick}>
                            {t('signup')}
                          </a>
                        </li>
                      </>
                    )}
                  </ul>
                )
              }

            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Navbar;
